export const APP_CONSTANTS = {
	LOCAL_STORAGE_KEY_IGNORE_SAVE_DATA: "ignoreSaveData",
	LOCAL_STORAGE_KEY_SAVE_DATA: "saveData",
	LOCAL_STORAGE_SHOW_HIDDDEN_OPTIONS: "showHiddenOptions",
};
